<div class="sidebar" [ngClass]="{ support: isActiveSupportMode }" #sideBar>
  <div class="h-100 position-relative" [ngClass]="{ 'overflow-hidden': isActiveSupportMode }">
    <div class="user-company-info">
      <company-info [(open)]="openCompanies"></company-info>
    </div>
    <div class="logo-container">
      <img alt="logo" src="/assets/images/logo-site.svg" />
    </div>
    <div *ngIf="isActiveUserMode" class="user-company-edit">
      <a (click)="openSettingSidebar($event)">
        <span class="icon-ic icon-ic_edit"></span>
        {{ "MENU.ACCOUNT_SETTINGS" | translate }}
      </a>
    </div>
    <nav>
      <ul class="sidebar-menu" [ngClass]="{ 'is-user-mode': isActiveUserMode }">
        <ng-template ngFor let-item [ngForOf]="menuItemSettings" [ngForTrackBy]="trackByMenuItem">
          <ng-template [ngIf]="item.children" [ngIfElse]="childMenuItemTemplate">
            <li [routerLinkActive]="['active']" [attr.data-test-label]="'root-menu-' + item - item.menuItem">
              <span *ngIf="!item.iconUrl" (click)="toggleMenuItem(item.menuItem)" [ngClass]="{ opened: openedMenuItem(item.menuItem) }">
                <i class="fa fa-chevron-down" [ngClass]="{ opened: openedMenuItem(item.menuItem) }" aria-hidden="true"></i>
                <span>{{ "MENU." + item.title | translate }}</span>
              </span>

              <span ngClass="root-menu-item-with-icon" *ngIf="!!item.iconUrl">
                <img class="icon-by-url" [src]="'assets/icons/' + item.iconUrl" />
                <span>{{ "MENU." + item.title | translate }}</span>
              </span>

              <ul [collapse]="isActiveUserMode ? false : !openedMenuItem(item.menuItem)" [isAnimated]="true">
                <!--                //TODO : remove ngClass with d-none after adding mobile view to bonds page-->
                <li
                  *ngFor="let childMenuItem of item.children"
                  [attr.data-test-label]="'child-menu-item-' + childMenuItem.title"
                  [ngClass]="{ 'd-none': childMenuItem.title === 'CUSTOMS_BONDS' && (isTablet$ | async) }"
                >
                  <a
                    [attr.data-test-label]="childMenuItem.title + '-with-add-button'"
                    [ngClass]="{ 'with-plus': childMenuItem.plus }"
                    [routerLink]="childMenuItem.routerLink"
                    [routerLinkActive]="['active']"
                  >
                    <span>
                      <ng-container *ngIf="!!childMenuItem.iconUrl">
                        <img class="icon-by-url-child" [src]="'assets/icons/' + childMenuItem.iconUrl" />
                      </ng-container>

                      <ng-container *ngIf="!childMenuItem.iconUrl">
                        <span class="icon-by-url-child"><img src="assets/icons/icon_chevron_right.svg" /></span>
                        <span>{{ "MENU." + childMenuItem.title | translate }}</span>
                      </ng-container>
                    </span>
                    <span
                      class="icon-ic icon-ic_plus"
                      nz-tooltip
                      nzTooltipPlacement="right"
                      nzTooltipColor="#ffffff"
                      nzTooltipOverlayClassName="tooltip-sm"
                      *ngIf="childMenuItem.plus && !isShowBulkDropdown(childMenuItem)"
                      [attr.data-test-label]="item.title + '-add-button'"
                      [nzTooltipTitle]="childMenuItem.plus?.tooltip | translate"
                      [routerLink]="childMenuItem.plus.routerLink"
                      (click)="childMenuItem.plus.click($event)"
                    ></span>

                    <div
                      dropdown
                      container="body"
                      placement="bottom right"
                      *ngIf="isShowBulkDropdown(childMenuItem)"
                      (click)="preventDefaultClick($event)"
                    >
                      <span class="icon-ic icon-ic_plus" dropdownToggle></span>

                      <div *dropdownMenu class="dropdown-menu dropdown-menu-right custom">
                        <button
                          dropdown-item
                          type="button"
                          class="dropdown-item"
                          *ngFor="let dropdownItem of childMenuItem.dropdown"
                          (click)="openChildAction(dropdownItem)"
                        >
                          {{ dropdownItem.title | translate }}
                        </button>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          </ng-template>
          <ng-template #childMenuItemTemplate>
            <li
              *ngIf="item"
              [attr.data-test-label]="'child-menu-item-' + item.title"
              [ngClass]="{ 'is-bottom': item.attachedToBottom, 'is-top': item.attachedToTop }"
            >
              <a
                [ngClass]="{ 'with-plus': item.plus }"
                [routerLink]="item.routerLink"
                [routerLinkActive]="['active']"
                [attr.data-test-label]="item.title + '-with-add-button'"
              >
                <span *ngIf="!item.iconUrl">
                  <span class="icon-ic" [ngClass]="item.icon"></span>
                  <span>{{ "MENU." + item.title | translate }}</span>
                </span>

                <span *ngIf="!!item.iconUrl">
                  <img class="icon-by-url" [src]="'assets/icons/' + item.iconUrl" />
                  <span>{{ "MENU." + item.title | translate }}</span>
                </span>

                <span
                  class="icon-ic icon-ic_plus"
                  *ngIf="item.plus"
                  [routerLink]="item.plus.routerLink"
                  [attr.data-test-label]="item.title + '-add-button'"
                  (click)="item.plus.click($event)"
                ></span>
              </a>
            </li>
            <li *ngIf="item && item.title === 'DRIP' && !(isTablet$ | async)" [ngClass]="{ 'trustpilot-widget-container': true }">
              <app-trustpilot-widget
                [templateId]="'53aa8807dec7e10d38f59f32'"
                [styleHeight]="'150px'"
                [styleWidth]="'100%'"
                [theme]="'dark'"
                [token]="'e4be3181-cd0e-4e70-a303-3dadc1012b27'"
              ></app-trustpilot-widget>
            </li>
          </ng-template>
        </ng-template>
        <li class="setting-action" *ngIf="isAllowSwitchMode">
          <a (click)="switchActiveApplicationMode()">
            <span class="icon-ic icon-ic_admin"></span>
            <span>{{ "MENU.SWITCH_TO_ROLE_" + (isActiveSupportMode ? "USER" : "SUPPORT") | translate }}</span>
          </a>
        </li>
        <li class="is-bottom">
          <a [routerLink]="'/contact-support'">
            <span><img class="icon-by-url" [src]="'assets/icons/icon_mail_green.svg'" /></span>
            <span>{{ "MENU.SUPPORT" | translate }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div class="beta" [ngClass]="{ 'bg-dark-gray': !(isMobile$ | async) }">
    <div *ngIf="(isTablet$ | async) && isActiveUserMode">
      <app-trustpilot-widget
        [templateId]="'53aa8807dec7e10d38f59f32'"
        [styleHeight]="'100px'"
        [styleWidth]="'75%'"
        [theme]="'light'"
        [token]="'e4be3181-cd0e-4e70-a303-3dadc1012b27'"
      ></app-trustpilot-widget>
    </div>
    <div class="mb-2">
      <app-last-login-attempt></app-last-login-attempt>
    </div>
    <span *ngIf="isSupportOrAdmin">
      {{ (version$ | async).version }}
      ({{ (version$ | async).timestamp | customDateTimeByUtc }})
    </span>
    <span>
      <a *ngIf="isActiveUserMode" [routerLink]="'/legal-terms'">{{ "LABELS.TERMS" | translate }}</a>
      &
      <a *ngIf="isActiveUserMode" [routerLink]="'/privacy-policy'">{{ "LABELS.PRIVACY" | translate }}</a>
    </span>
    <span>
      <a href="javascript:void(0);" (click)="onOpenCookieSettings()">{{ "COOKIES_SETTINGS" | translate }}</a>
    </span>
  </div>
</div>
